import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        debugMode: false,        
        apiURL: 'http://127.0.0.1:8080/api/',
        vkURL: 'https://vk.com/renewation',
		homeURL: 'https://mod.worms.pro/',
		coversURL: 'https://mod.worms.pro/resources/content/xl/',
        imagesURL: 'https://mod.worms.pro/resources/galery/',
		//homeURL: 'http://localhost:8080/',
		//coversURL: 'http://localhost/mod.worms.pro/resources/content/xl/',
		//imagesURL: 'http://localhost/mod.worms.pro/resources/galery/',
        youtubeURL: 'https://www.youtube.com/channel/UCrDifANbcCEC4b-vUGTtlPg',
		discordURL: 'https://discord.gg/sdKqGu6',
        forumURL: 'http://w4tweaks.ru/forum/171',
        modURL1: 'https://mod.worms.pro/resources/Renewation_0.7.8.exe',
        modURL2: 'https://mod.worms.pro/resources/Renewation_0.7.8.zip',
        modHDURL1: 'https://mod.worms.pro/resources/RenewationHD_0.2A2.exe',
        modHDURL2: 'https://mod.worms.pro/resources/RenewationHD_0.2A2.zip',
        modHDMirror1: 'https://drive.google.com/file/d/1YSkNYO1UAJ7rfDBci6-P06iWIEfczj7v/view?usp=sharing',
        modHDMirror2: 'https://drive.google.com/file/d/147czayCg1YcFcLhOoJwGgm5i9mB7E9LE/view?usp=sharing',
		setLanguage: 'ru',
        updates: [
            {
                type: 'new',
                date: '2023-11-07',
                notes: [
                    ['Добавлена новая одежда - Гоблин','New clothing added - Goblin','/clothes/Goblin'],
                    ['Добавлена новая одежда - Шапка Бини','New clothing added - Beanie','/clothes/Beanie'],
                    ['Ширина трассы для роупинга на карте Empty Walls увеличена для большего удобства','The width of the roping track on the Empty Walls map has been increased for greater convenience',''],
                    ['Устранены вспышки на экране при некоторых анимациях интерфейса','Screen flashes during certain interface animations have been fixed',''],
                    ['Улучшен эффект частиц при использовании Волшебной пули','Improved particle effect when using the Magic Bullet',''],
                ],
                released: true
            },
            {
                type: 'new',
                date: '2023-10-10',
                notes: [
                    ['Улучшен внешний вид и удобство панели очков в режиме RopeRace (RR)','The appearance and convenience of the scoreboard in RopeRace (RR) gamemode have been improved',''],
                    ['Устранены вылеты игры при незакрытии панели очков до начала следующего хода','Game crashes when the score panel is not closed before the start of the next turn have been fixed',''],
                    ['Исправлено отображение некоторых текстур на карте [DM] Greece 2','Display issues with some textures on the [DM] Greece 2 map have been fixed',''],
                ],
                released: true
            }
        ],
        components: [
                {
                    type: 'gamemodes',
                    authors: ['firsacho'],
                    title: '[BB] Bridge Build',
                    text: 'BBTXT',
                    game: 3, // 1 - W4M, 2 - WUM, 3 - both, 4 - coming soon
                    subtexts: ['BBObj1','BBObj2','BBObj3'],
                    image: 'bb',
                    video: 'none',
                    galeryArray: ['none'],
                },
                {
                    type: 'gamemodes',
                    authors: ['Profile'],
                    title: '[BnA] Bow and Arrows',
                    text: 'BnATXT',
                    game: 2,
                    subtexts: ['BnAObj1','BnAObj2','BnAObj3'],
                    image: 'bna',
                    video: 'none',
                    galeryArray: ['none'],
                },
                {
                    type: 'gamemodes',
                    authors: ['firsacho'],
                    title: '[BOX]',
                    text: 'BOXTXT',
                    game: 3,
                    subtexts: ['BOXObj1','BOXObj2','BOXObj3'],
                    image: 'box',
                    video: 'none',
                    galeryArray: ['none'],
                },
                {
                    type: 'gamemodes',
                    authors: ['firsacho'],
                    title: '[CS] Castle Siege',
                    text: 'CSTXT',
                    game: 2,
                    subtexts: ['CSObj1','CSObj2','CSObj3'],
                    image: 'cs',
                    video: 'none',
                    galeryArray: ['none'],
                }, 
                {
                    type: 'gamemodes',
                    authors: ['Profile','firsacho'],
                    title: '[GG] Gun Game',
                    text: 'GGTXT',
                    game: 2,
                    subtexts: ['GGObj1','GGObj2','GGObj3'],
                    image: 'gg',
                    video: 'none',
                    galeryArray: ['https://youtu.be/lQNPHF7m4n0'],
                }, 
                {
                    type: 'gamemodes',
                    authors: ['Profile','firsacho'],
                    title: '[ND] NUCLEAR DEFUSE',
                    text: 'NDOLDTXT',
                    game: 1,
                    subtexts: ['NDOLDObj1','NDOLDObj2','NDOLDObj3'],
                    image: 'ndold',
                    video: 'none',
                    galeryArray: ['none'],
                }, 
                {
                    type: 'gamemodes',
                    authors: ['Profile','firsacho'],
                    title: '[ND] NUCLEAR DOMINATION',
                    text: 'NDTXT',
                    game: 2,
                    subtexts: ['NDObj1','NDObj2','NDObj3'],
                    image: 'nd',
                    video: 'none',
                    galeryArray: ['none'],
                },
                {
                    type: 'gamemodes',
                    authors: ['firsacho'],
                    title: '[PRO] PRO MODE',
                    text: 'PROTXT',
                    game: 3,
                    subtexts: ['PROObj1','PROObj2','PROObj3'],
                    image: 'pro',
                    video: 'none',
                    galeryArray: ['none'],
                },                
                {
                    type: 'gamemodes',
                    authors: ['firsacho'],
                    title: '[RR] Rope Race (OLD)',
                    text: 'RROLDTXT',
                    game: 1,
                    subtexts: ['RROLDObj1','RROLDObj2','RROLDObj3'],
                    image: 'rrold',
                    video: 'none',
                    galeryArray: ['none'],
                },
                {
                    type: 'gamemodes',
                    authors: ['firsacho'],
                    title: '[RR] Rope Race',
                    text: 'RRTXT',
                    game: 2,
                    subtexts: [],
                    image: 'rr',
                    video: 'none',
                    galeryArray: ['https://youtu.be/PLTjtVB08-Y'],
                },
                {
                    type: 'gamemodes',
                    authors: ['PROFILE, firsacho'],
                    title: '[TF2] Team Fortress 2',
                    text: 'TF2TXT',
                    game: 3,
                    subtexts: ['TF2Obj1','TF2Obj2','TF2Obj3'],
                    image: 'tf2',
                    video: 'none',
                    galeryArray: ['none'],
                },
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[DM] 911',
                    text: 'map911',
                    game: 3,
                    image: '911',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                }, 
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[PRO] Blocks 4x4x4',
                    text: 'map4x4x4',
                    game: 3,
                    image: '4x4x4',
                    video: 'none',
                    galeryArray: ['0','1','2'],
                },                
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[BB] Bridge Build',
                    text: 'BridgeBuild',
                    game: 3,
                    image: 'BridgeBuild',
                    video: 'none',
                    galeryArray: ['0','1','2'],
                },
                {
                    type: 'maps',
                    authors: ['agent007'],
                    title: '[ND] Battleships',
                    text: 'dd_battleships',
                    game: 1,
                    image: 'dd_battleships',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },
                {
                    type: 'maps',
                    authors: ['agent007','firsacho'],
                    title: '[HL] Battleships 2',
                    text: 'dd_battleships2',
                    game: 2,
                    image: 're_battleships',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },				
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[DM] Cap Map',
                    text: 'dm_capmap',
                    game: 3,
                    image: 'dm_capmap',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },                 
                {
                    type: 'maps',
                    authors: ['vera34'],
                    title: '[DM] Castle in Sky',
                    text: 'dm_castleinsky',
                    game: 3,
                    image: 'dm_castleinsky',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8','9','10','11'],
                }, 
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[CS] Castle Siege',
                    text: 'cs_castlesiege',
                    game: 3,
                    image: 'cs_castlesiege',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },                
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[HL] Castles XL',
                    text: 'homelands1',
                    game: 1,
                    image: 'homelands1',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[HL] Castles 2XL',
                    text: 'homelands2',
                    game: 2,
                    image: 're_homelands1',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6','7','8','9','10','11','12'],
                },
                {
                    type: 'maps',
                    authors: ['Unaited'],
                    title: '[DM] Crash Arena',
                    text: 'CrashArena',
                    game: 3,
                    image: 'CrashArena',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },                 
                {
                    type: 'maps',
                    authors: ['agent007'],
                    title: '[DM] Desert Road 2',
                    text: 'dm_desertroad',
                    game: 3,
                    image: 'dm_desertroad',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7'],
                },                
                {
                    type: 'maps',
                    authors: ['PROFILE','agent007','AlexBond'],
                    title: '[DM] Egypt 2',
                    text: 'dm_egypt',
                    game: 3,
                    image: 'dm_egypt',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8','9','10','11'],
                }, 
                {
                    type: 'maps',
                    authors: ['agent007'],
                    title: '[DM] Electronics 2',
                    text: 'dm_electronics',
                    game: 3,
                    image: 'dm_electronics',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },                                  
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[RR] Empty Walls',
                    text: 'EmptyWalls',
                    game: 3,
                    image: 'EmptyWalls',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },
                {
                    type: 'maps',
                    authors: ['Sergey'],
                    title: '[DM] Flood Island',
                    text: 'FloodIsland',
                    game: 3,
                    image: 'FloodIsland',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7'],
                }, 
                {
                    type: 'maps',
                    authors: ['agent007'],
                    title: '[DM] Food Table',
                    text: 'dm_foodtable',
                    game: 3,
                    image: 'dm_foodtable',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },                  
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: "[PRO] Forest of Ninja's",
                    text: 'forest',
                    game: 3,
                    image: 'forest',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                }, 
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[FAF] From a Flood',
                    text: 'faf1',
                    game: 3,
                    image: 'faf1',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8','9','10','11'],
                },                  
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[PRO] Great Sphere',
                    text: 'dm_greatsphere',
                    game: 3,
                    image: 'dm_greatsphere',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },                 
                {
                    type: 'maps',
                    authors: ['PROFILE','agent007'],
                    title: '[DM] Greece 2',
                    text: 'dm_greece',
                    game: 3,
                    image: 'dm_greece',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8','9','10','11'],
                },                 
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[BOX] Headshot',
                    text: 'headshot',
                    game: 3,
                    image: 'headshot',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },
                {
                    type: 'maps',
                    authors: ['agent007'],
                    title: '[TF2] Illusion',
                    text: 'tf2_illusion',
                    game: 3,
                    image: 'tf2_illusion',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7'],
                },				
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[DM] Insectoid Attack',
                    text: 'InsectoidAttack',
                    game: 3,
                    image: 'InsectoidAttack',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },
                {
                    type: 'maps',
                    authors: ['Vera34'],
                    title: '[DM] In Water',
                    text: 'InWater',
                    game: 3,
                    image: 'InWater',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7'],
                },                 
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[BOX] Jungle',
                    text: 'jungle',
                    game: 3,
                    image: 'jungle',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8','9','10','11'],
                },
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[DM] Jungle Temple',
                    text: 'JungleTemple',
                    game: 3,
                    image: 'JungleTemple',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },
                {
                    type: 'maps',
                    authors: ['Emishka'],
                    title: '[PRO] Levitation',
                    text: 're_Levitation',
                    game: 2,
                    image: 're_Levitation',
                    video: 'none',
                    galeryArray: ['1','2'],
                },
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[DM] MazeTowers',
                    text: 're_MazeTowers',
                    game: 2,
                    image: 're_MazeTowers',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },
                {
                    type: 'maps',
                    authors: ['agent007','firsacho'],
                    title: '[HL] Medieval',
                    text: 're_medieval',
                    game: 2,
                    image: 're_medieval',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[DM] Playground',
                    text: 'dm_playground',
                    game: 3,
                    image: 'dm_playground',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },                
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[PRO] Poxel Art',
                    text: 'dm_poxelart',
                    game: 1,
                    image: 'dm_poxelart',
                    video: 'none',
                    galeryArray: ['1','2','3','4'],
                },
                {
                    type: 'maps',
                    authors: ['Quete'],
                    title: '[PRO] Promap',
                    text: 'promap',
                    game: 3,
                    image: 'promap',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },                 
                {
                    type: 'maps',
                    authors: ['Vera34'],
                    title: '[BOX] Room',
                    text: 'Room',
                    game: 3,
                    image: 'Room',
                    video: 'none',
                    galeryArray: ['0','1','2'],
                },                 
                {
                    type: 'maps',
                    authors: ['firsacho'],
                    title: '[RR] Save the princess!',
                    text: 'rr_mario',
                    game: 1,
                    image: 'rr_mario',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8','9','10','11'],
                }, 
                {
                    type: 'maps',
                    authors: ['agent007'],
                    title: '[DM] Secret Station 2',
                    text: 'dm_secretstation',
                    game: 3,
                    image: 'dm_secretstation',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },              
                {
                    type: 'maps',
                    authors: ['agent007', '4erver'],
                    title: '[DM] Street',
                    text: 'dm_street',
                    game: 1,
                    image: 'dm_street',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8','9','10','11'],
                },
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[HL] Tears of Heaven City',
                    text: 'hl_tears',
                    game: 3,
                    image: 'hl_tears',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[PRO] Tetrahedron',
                    text: 're_tetrahedron',
                    game: 2,
                    image: 're_tetrahedron',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },
                {
                    type: 'maps',
                    authors: ['PROFILE'],
                    title: '[PRO] Underwater World',
                    text: 'dm_underwaterworld',
                    game: 3,
                    image: 'dm_underwaterworld',
                    video: 'none',
                    galeryArray: ['0','1','2'],
                },                 
                {
                    type: 'maps',
                    authors: ['Nezon'],
                    title: '[DM] Victory Or Death',
                    text: 'VictoryOrDeath',
                    game: 3,
                    image: 'VictoryOrDeath',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },                 
                {
                    type: 'maps',
                    authors: ['ATOM'],
                    title: '[DM] Worm City',
                    text: 'WormCity',
                    game: 1,
                    image: 'WormCity',
                    video: 'none',
                    galeryArray: [],
                },
                {
                    type: 'maps',
                    authors: ['Emishka'],
                    title: '[RR] Wyvern',
                    text: 're_Wyvern',
                    game: 2,
                    image: 're_Wyvern',
                    video: 'none',
                    galeryArray: ['https://youtu.be/PLTjtVB08-Y','0','1','2','3','4','5','6','7','8','9','10'],
                },
                {
                    type: 'maps',
                    authors: ['Nezon'],
                    title: '[DM] Ziggurat',
                    text: 'Ziggurat',
                    game: 3,
                    image: 'Ziggurat',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                }, 
                {
                    type: 'missions',
                    authors: ['firsacho'],
                    title: '[RR] Empty Walls',
                    text: 'LevelRRTXT',
                    game: 3,
                    image: 'single_EmptyWalls',
                    subtexts: ['LevelRRObj1','LevelRRObj2','LevelRRObj3'],
                    galeryArray: ['none'],
                },
                {
                    type: 'missions',
                    authors: ['firsacho'],
                    title: '[FAF] From a Flood',
                    text: 'LevelFAFTXT',
                    game: 3,
                    image: 'single_arabic',
                    subtexts: ['LevelRRObj1','LevelRRObj2','LevelRRObj3'],
                    galeryArray: ['none'],
                },                 
                {
                    type: 'missions',
                    authors: ['firsacho'],
                    title: '[RR] Save the princess!',
                    text: 'LevelRRTXT',
                    game: 1,
                    image: 'single_mario',
                    subtexts: ['LevelRRObj1','LevelRRObj2','LevelRRObj3'],
                    galeryArray: ['none'],
                },
                {
                    type: 'missions',
                    authors: ['Zelenium','firsacho'],
                    title: 'Miner Boss',
                    text: 'LevelBoss1TXT',
                    game: 2,
                    image: 'single_VictoryOrDeath',
                    subtexts: ['LevelBoss1Obj1','LevelBoss1Obj2','LevelBoss1Obj3'],
                    galeryArray: ['none'],
                }, 
                {
                    type: 'missions',
                    authors: ['Zelenium','firsacho'],
                    title: 'Pirates Boss',
                    text: 'LevelBoss2TXT',
                    game: 2,
                    image: 'single_InWater',
                    subtexts: ['LevelBoss2Obj1','LevelBoss2Obj2','LevelBoss2Obj3'],
                    galeryArray: ['none'],
                }, 
                {
                    type: 'missions',
                    authors: ['Zelenium','firsacho'],
                    title: 'Demon Boss',
                    text: 'LevelBoss3TXT',
                    game: 2,
                    image: 'single_MazeTowers',
                    subtexts: ['LevelBoss3Obj1','LevelBoss3Obj2','LevelBoss3Obj3'],
                    galeryArray: ['none'],
                }, 
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'BoostedBazooka',
                    text: 'BoostedBazooka',
					subtexts: [],
                    game: 3,
                    image: 'BoostedBazooka',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                }, 
                {
                    type: 'weapons',
                    authors: ['PrIzRaK','firsacho'],
                    title: 'Magic Bullet',
                    text: 'MagicBullet',
                    game: 3,
                    image: 'MagicBullet',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                }, 
                {
                    type: 'weapons',
                    authors: ['PrIzRaK','firsacho'],
                    title: 'Pistol',
                    text: 'Pistol',
                    game: 3,
                    image: 'Pistol',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                },  
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'AKS74U',
                    text: 'AKS74U',
                    game: 3,
                    image: 'AKS74U',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },  
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'MineLauncher',
                    text: 'MineLauncher',
                    game: 3,
                    image: 'MineLauncher',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },  
                {
                    type: 'weapons',
                    authors: ['PrIzRaK','firsacho'],
                    title: 'VacumBomb',
                    text: 'VacumBomb',
                    game: 3,
                    image: 'VacumBomb',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'Buffalo',
                    text: 'Buffalo',
                    game: 3,
                    image: 'Buffalo',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },  
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'BoostedJetpack',
                    text: 'BoostedJetpack',
                    game: 3,
                    image: 'BoostedJetpack',
                    video: 'none',
                    galeryArray: ['0'],
                },  
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'BoostedAirstrike',
                    text: 'BoostedAirstrike',
                    game: 3,
                    image: 'BoostedAirstrike',
                    video: 'none',
                    galeryArray: ['0','1'],
                },  
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'BoostedRope',
                    text: 'BoostedRope',
                    game: 3,
                    image: 'BoostedRope',
                    video: 'none',
                    galeryArray: ['0','1'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE','firsacho','4erver'],
                    title: 'Petrol',
                    text: 'Petrol',
                    game: 3,
                    image: 'Petrol',
                    video: 'none',
                    galeryArray: ['0','1'],
                },   
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'Suicide',
                    text: 'Suicide',
                    game: 3,
                    image: 'Suicide',
                    video: 'none',
                    galeryArray: ['0'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE','firsacho'],
                    title: 'BrutalMine',
                    text: 'BrutalMine',
                    game: 3,
                    image: 'BrutalMine',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },
                {
                    type: 'weapons',
                    authors: ['firsacho','Woitek','Master_Erdees'],
                    title: 'Nuclear Beacon (ND)',
                    text: 'NuclearBeacon',
                    game: 3,
                    image: 'NuclearBeacon',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                },				
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Grenade Launcher (TF2)',
                    text: 'TF2GLauncher',
                    game: 3,
                    image: 'TF2GLauncher',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                },
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Sticky Bomb Launcher (TF2)',
                    text: 'TF2StickyLauncher',
                    game: 3,
                    image: 'TF2StickyLauncher',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Wrench (TF2)',
                    text: 'TF2Wrench',
                    game: 3,
                    image: 'TF2Wrench',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },  
                {
                    type: 'weapons',
                    authors: ['firsacho'],
                    title: 'Medigun (TF2)',
                    text: 'TF2Medigun',
                    game: 3,
                    image: 'TF2Medigun',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Syringe Gun (TF2)',
                    text: 'TF2SyringeGun',
                    game: 3,
                    image: 'TF2SyringeGun',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Flame Thrower (TF2)',
                    text: 'TF2FlameThrower',
                    game: 3,
                    image: 'TF2FlameThrower',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Fire Axe (TF2)',
                    text: 'TF2FireAxe',
                    game: 3,
                    image: 'TF2FireAxe',
                    video: 'none',
                    galeryArray: ['0','1','2'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Scattergun (TF2)',
                    text: 'TF2Scattergun',
                    game: 3,
                    image: 'TF2Scattergun',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Rocket launcher (TF2)',
                    text: 'TF2RocketLauncher',
                    game: 3,
                    image: 'TF2RocketLauncher',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6'],
                },  
                {
                    type: 'weapons',
                    authors: ['PROFILE'],
                    title: 'Showel (TF2)',
                    text: 'TF2Showel',
                    game: 3,
                    image: 'TF2Showel',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                },  
                {
                    type: 'skins',
                    authors: ['Unaited'],
                    title: 'Bazooka',
                    text: 'Bazooka',
                    game: 3,
                    image: 'Bazooka',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },  
                {
                    type: 'skins',
                    authors: [''],
                    title: 'BaseballBat',
                    text: 'BaseballBat',
                    game: 3,
                    image: 'BaseballBat',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },
                {
                    type: 'skins',
                    authors: ['firsacho'],
                    title: 'Beacon',
                    text: 'Beacon',
                    game: 2,
                    image: 'Beacon',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4'],
                }, 
                {
                    type: 'skins',
                    authors: ['Master_Erdees'],
                    title: 'Grenade',
                    text: 'Grenade',
                    game: 2,
                    image: 'Grenade',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },
                {
                    type: 'skins',
                    authors: ['PrIzRaK'],
                    title: 'Shotgun',
                    text: 'Shotgun',
                    game: 3,
                    image: 'Shotgun',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },  
                {
                    type: 'skins',
                    authors: ['Skript47'],
                    title: 'SniperRifle',
                    text: 'SniperRifle',
                    game: 3,
                    image: 'SniperRifle',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },  
                {
                    type: 'skins',
                    authors: ['SW_Krash'],
                    title: 'ClusterGrenade',
                    text: 'ClusterGrenade',
                    game: 3,
                    image: 'ClusterGrenade',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },  
                {
                    type: 'skins',
                    authors: ['Vorobey'],
                    title: 'GasGrenade',
                    text: 'GasGrenade',
                    game: 3,
                    image: 'GasGrenade',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                }, 
				{
                    type: 'skins',
                    authors: ['egokarpo'],
                    title: 'Dynamite',
                    text: 'Dynamite',
                    game: 3,
                    image: 'Dynamite',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },  				
                {
                    type: 'skins',
                    authors: ['PROFILE'],
                    title: 'TailNail',
                    text: 'TailNail',
                    game: 3,
                    image: 'TailNail',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },  
                {
                    type: 'skins',
                    authors: ['Unaited'],
                    title: 'RedBullCan',
                    text: 'RedBullCan',
                    game: 3,
                    image: 'RedBullCan',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },  
                {
                    type: 'skins',
                    authors: ['4erver'],
                    title: 'HealthCrate',
                    text: 'HealthCrate',
                    game: 3,
                    image: 'HealthCrate',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },
                {
                    type: 'skins',
                    authors: ['firsacho'],
                    title: 'UtilityCrate',
                    text: 'UtilityCrate',
                    game: 2,
                    image: 'UtilityCrate',
                    video: 'none',
                    galeryArray: ['0','1','2','3'],
                },  
                {
                    type: 'skins',
                    authors: ['Firsacho'],
                    title: 'Barrel',
                    text: 'Barrel',
                    game: 3,
                    image: 'Barrel',
                    video: 'none',
                    galeryArray: ['0','1','2','3','4','5','6','7','8'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Alpha Squad',
                    text: 'AlphaSquad',
                    game: 3,
                    image: 'AlphaSquad',
                    video: 'none',
                    galeryArray: ['1','2','3'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Mortarboard',
                    text: 'Mortarboard',
                    game: 3,
                    image: 'Mortarboard',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Red Army Hat',
                    text: 'RedArmyHat',
                    game: 3,
                    image: 'RedArmyHat',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Cook Hat',
                    text: 'CookHat',
                    game: 3,
                    image: 'CookHat',
                    video: 'none',
                    galeryArray: ['1','2','3'],
                },
				{
                    type: 'clothes',
                    authors: ['Unaited'],
                    title: 'Visor',
                    text: 'Visor',
                    game: 3,
                    image: 'Visor',
                    video: 'none',
                    galeryArray: ['1','2','3'],
                },
				{
                    type: 'clothes',
                    authors: ['Firsacho'],
                    title: 'USSR Cap',
                    text: 'USSRCap',
                    game: 3,
                    image: 'USSRCap',
                    video: 'none',
                    galeryArray: ['1','2','3','4'],
                },
				{
                    type: 'clothes',
                    authors: ['PrIzRaK'],
                    title: 'Nyan Cat',
                    text: 'NyanCat',
                    game: 3,
                    image: 'NyanCat',
                    video: 'none',
                    galeryArray: ['1','2','3','4'],
                },
				{
                    type: 'clothes',
                    authors: ['Firsacho'],
                    title: 'Roper Cap',
                    text: 'RoperCap',
                    game: 3,
                    image: 'RoperCap',
                    video: 'none',
                    galeryArray: ['1','2','3','4'],
                },
				{
                    type: 'clothes',
                    authors: ['Firsacho'],
                    title: 'Must Die Cap',
                    text: 'MustDieCap',
                    game: 3,
                    image: 'MustDieCap',
                    video: 'none',
                    galeryArray: ['none'],
                },
				{
                    type: 'clothes',
                    authors: ['Firsacho'],
                    title: 'Headcrab',
                    text: 'Headcrab',
                    game: 3,
                    image: 'Headcrab',
                    video: 'none',
                    galeryArray: ['1','2','3'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Farmer Hat',
                    text: 'FarmerHat',
                    game: 3,
                    image: 'FarmerHat',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Headphones',
                    text: 'Headphones',
                    game: 3,
                    image: 'Headphones',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6'],
                },
				{
                    type: 'clothes',
                    authors: ['Skript47'],
                    title: 'Devil Mask',
                    text: 'DevilMask',
                    game: 3,
                    image: 'DevilMask',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6'],
                },
				{
                    type: 'clothes',
                    authors: ['PrIzRaK'],
                    title: 'Paper Bag',
                    text: 'PaperBag',
                    game: 3,
                    image: 'PaperBag',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6'],
                },
				{
                    type: 'clothes',
                    authors: ['RPOFILE'],
                    title: 'Tank Headset',
                    text: 'TankHeadset',
                    game: 3,
                    image: 'TankHeadset',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6'],
                },
				{
                    type: 'clothes',
                    authors: ['Unaited'],
                    title: 'Amy Rose',
                    text: 'AmyRose',
                    game: 3,
                    image: 'AmyRose',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5','6'],
                },
				{
                    type: 'clothes',
                    authors: ['Unaited'],
                    title: 'Sonic',
                    text: 'Sonic',
                    game: 3,
                    image: 'Sonic',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5'],
                },
				{
                    type: 'clothes',
                    authors: ['PrIzRaK'],
                    title: 'Welding Helmet',
                    text: 'WeldingHelmet',
                    game: 3,
                    image: 'WeldingHelmet',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5'],
                },
				{
                    type: 'clothes',
                    authors: ['Unaited'],
                    title: 'Austronaut',
                    text: 'Austronaut',
                    game: 3,
                    image: 'Austronaut',
                    video: 'none',
                    galeryArray: ['1','2','3'],
                },
				{
                    type: 'clothes',
                    authors: ['Firsacho'],
                    title: 'Devil Horns',
                    text: 'DevilHorns',
                    game: 3,
                    image: 'DevilHorns',
                    video: 'none',
                    galeryArray: ['1','2','3'],
                },
				{
                    type: 'clothes',
                    authors: ['PrIzRaK'],
                    title: 'Aimer',
                    text: 'Aimer',
                    game: 3,
                    image: 'Aimer',
                    video: 'none',
                    galeryArray: ['1','2'],
                },
				{
                    type: 'clothes',
                    authors: ['PrIzRaK'],
                    title: 'Smiles',
                    text: 'Smiles',
                    game: 3,
                    image: 'Smiles',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Hipster',
                    text: 'Hipster',
                    game: 3,
                    image: 'Hipster',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Dollars',
                    text: 'Dollars',
                    game: 3,
                    image: 'Dollars',
                    video: 'none',
                    galeryArray: ['1','2','3','4'],
                },
				{
                    type: 'clothes',
                    authors: ['PROFILE'],
                    title: 'Shutter Glasses',
                    text: 'ShutterGlasses',
                    game: 3,
                    image: 'ShutterGlasses',
                    video: 'none',
                    galeryArray: ['1','2'],
                },
				{
                    type: 'clothes',
                    authors: ['Unaited'],
                    title: 'Backpack',
                    text: 'Backpack',
                    game: 3,
                    image: 'Backpack',
                    video: 'none',
                    galeryArray: ['1','2','3','4'],
                },
				{
                    type: 'clothes',
                    authors: ['egokarpo'],
                    title: 'Respirator',
                    text: 'Respirator',
                    game: 3,
                    image: 'Respirator',
                    video: 'none',
                    galeryArray: ['none'],
                },
                {
                    type: 'clothes',
                    authors: ['Master_Erdees','Stinkek'],
                    title: 'Goblin',
                    text: 'Goblin',
                    game: 2,
                    image: 'Goblin',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5'],
                },
                {
                    type: 'clothes',
                    authors: ['Master_Erdees','Stinkek'],
                    title: 'Beanie',
                    text: 'Beanie',
                    game: 2,
                    image: 'Beanie',
                    video: 'none',
                    galeryArray: ['1','2','3','4','5'],
                },
				{
                    type: 'other',
                    authors: ['firsacho','ARTemich'],
                    title: 'Main Menu',
                    text: 'MainMenu',
                    game: 3,
                    image: 'MainMenu',
                    video: 'none',
                    galeryArray: ['none'],
                },
				{
                    type: 'other',
                    authors: ['firsacho'],
                    title: 'Pause Menu',
                    text: 'PauseMenu',
                    game: 3,
                    image: 'PauseMenu',
                    video: 'none',
                    galeryArray: ['none'],
                },				
				{
                    type: 'other',
                    authors: ['firsacho'],
                    title: 'Renewation HUD',
                    text: 'RenewationHUD',
                    game: 3,
                    image: 'RenewationHUD',
                    video: 'none',
                    galeryArray: ['none'],
                },
				{
                    type: 'other',
                    authors: ['KaMiKaZe'],
                    title: 'English Translation',
                    text: 'EnglishTranslation',
                    game: 3,
                    image: 'EnglishTranslation',
                    video: 'none',
                    galeryArray: ['none'],
                },
				{
                    type: 'other',
                    authors: ['firsacho'],
                    title: 'Russian Translation',
                    text: 'RussianTranslation',
                    game: 2,
                    image: 'RussianTranslation',
                    video: 'none',
                    galeryArray: ['none'],
                },
				{
                    type: 'other',
                    authors: ['Unaited'],
                    title: 'Anniversary Patch',
                    text: 'AnniversaryPatch',
                    game: 2,
                    image: 'AnniversaryPatch',
                    video: 'none',
                    galeryArray: ['none'],
                }],
    },
    actions: {
		SetLanguage(context, state){
			let lang = 'en';
			if (state) lang = state;
			context.commit ('SetLanguage', lang);
		},     
    },
    getters: {
        componentsByTypeCount: state => (type, game) => {
            //return this.getters.componentsByType(type).length
            return state.components.filter( comp => comp.type === type && comp.game === game | comp.game === 3).length
        }       
    },
    mutations:  {
		SetLanguage (state, payload) {
			this.state.setLanguage = payload;
		},
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js